import FormValidator from '@/js/plugins/formValidator'

const main = () => {
    if(!document.querySelector('#page-user-password-reset')) return;
    const formValidator = new FormValidator({
        renderAreaSelector: '#input-form',
        renderErrorCnt: false,
        renderErrorPosition: 'outer',
    });
}

export default main;
